<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-snackbar
          v-model="snackbar.visible"
          :color="snackbar.color"
          :timeout="snackbar.timeout"
          :top="snackbar.position === 'top'"
          max-width="400"
        >
          <v-layout align-center pr-4>
            <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
            <v-layout column>
              <div><strong>{{ snackbar.title }}</strong></div>
              <div>{{ snackbar.text }}</div>
            </v-layout>
          </v-layout>
          <template v-slot:action="{ attrs }">
          <v-btn icon v-bind="attrs" @click="snackbar.visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        </v-snackbar>
      </v-col>
    </v-row>
    <v-card class="mb-5 rounded-lg elevation-3">
      <v-card-title class="primary white--text py-3 px-4">
        <v-icon left color="white">mdi-table-edit</v-icon>
        Input Tabel KPI
      </v-card-title>
      <v-card-text class="pa-4 head-cardtext">
        <v-row class="head-row mt-1" align="center">
          <v-col cols="12" md="6" class="pt-4 pt-md-0">
            <div class="dropdown-container" style="position: relative;">
              <v-text-field
                v-model="searchQuery"
                label="Pilih Posisi"
                outlined
                dense
                height="40"
                class="my-0"
                hide-details
                clearable
                prepend-inner-icon="mdi-account-search"
                @focus="openDropdown"
                @input="handleSearchInput"
                @click:clear="clearSelection"
              ></v-text-field>
              
              <div 
                v-if="showDropdown && filteredDatas.length > 0" 
                class="custom-dropdown"
                @scroll.stop
              >
                <div 
                  v-for="(item, idx) in filteredDatas" 
                  :key="`${item.id}-${idx}`"
                  class="dropdown-item"
                  @click="selectItem(item)"
                >
                  {{ item.position_name }} - {{ item.name }}
                </div>
              </div>
              <div 
                v-if="showDropdown && filteredDatas.length === 0 && searchQuery" 
                class="custom-dropdown"
              >
                <div class="dropdown-item text-center grey--text">
                  Tidak ada hasil ditemukan
                </div>
              </div>
            </div>
          </v-col>
        <v-col cols="12" md="6" class="pt-md-0">
          <v-row dense class="action-buttons">
            <v-col cols="12" sm="4" md="6" class="d-flex align-center">
              <v-btn
                color="success"
                elevation="2"
                height="40"
                @click="getInputKpi()"
                class="text-white"
                block
              >
                <v-icon left>mdi-table-eye</v-icon>
                Tampilkan KPI
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" md="6" class="d-flex align-center">
              <v-btn
                color="blue darken-4"
                elevation="2"
                height="40"
                class="text-white"
                block
                @click="modale(selectedKpiText)"
                >
                <v-icon left>mdi-download</v-icon>
                Download KPI
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        </v-row>
      </v-card-text>
      <v-expansion-panels v-model="kpiTargetPanel" accordion flat tile class="kpi-target-panels section-card">
        <v-expansion-panel>
          <v-expansion-panel-header class="kpi-target-header subtitle-1 font-weight-bold px-4 red lighten-5" style="border-left: 4px solid #003871;">
            <div class="d-flex align-center">
              <v-icon left color="primary">mdi-target</v-icon>
              KPI Target
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col cols="12" md="3" class="ml-auto mb-0">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                  dense
                  outlined
                ></v-text-field>
            </v-col>
            <v-card-text class="pa-0">
        <v-data-table
          :headers="kpiHeaders"
          :items="kpiItems"
          :items-per-page="5"
          dense
          :search="search"
          class="kpi-target-table elevation-0"
          disable-sort
          >
          <template v-slot:no-data>
            <div class="pa-5 text-center">
              <v-icon large color="grey lighten-1" style="margin-left: 60px;">mdi-database-off</v-icon>
              <div class="mt-2 grey--text" style="margin-left: 60px;">Tidak ada data tersedia</div>
            </div>
          </template>
          <template v-slot:[`item.user_name`]="{ item }">
          	<div class="d-flex flex-wrap" style="gap:4px;">
				<v-chip v-for="(s, i) in (item.shares || [])" :key="i" small label>
				{{ s.user_name }}
				</v-chip>
        	</div>
          </template>
		  <template v-slot:[`item.is_accounting`]="{ item }">
			<v-chip v-if="item && item.is_accounting" small label color="green lighten-4">Yes</v-chip>
			<v-chip v-else small label color="grey lighten-3">No</v-chip>
		  </template>
		  <!-- div for annual target -->
		  <template v-slot:[`item.annual_target`]="{ item }">
			<div class="body-2 mt-2 font-weight-medium" type="number"> {{ formatThousandId(item ? item.annual_target : 0) }}</div>
		  </template>
        </v-data-table>
      </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="section-card">
      <div class="subtitle-1 font-weight-bold px-4 green lighten-5 d-flex align-center" style="border-left: 4px solid #4CAF50; min-height: 40px;">
        <v-icon left color="green darken-1">mdi-calendar-month</v-icon>
        Data Bulanan
      </div>
      <v-card-text class="mb-2">
        <div class="monthly-data-container">
          <v-card class="ma-3 summary-total-card" style="border: 4px solid #4CAF50;">
            <v-card-text class="pa-3">
              <div class="d-flex align-stretch summary-stats">
                <div class="text-center summary-stat">
                  <div class="subtitle-2 font-weight-bold">Score Total Current</div>
                  <div class="summary-stat-value blue--text text--darken-2">{{ kpiScore.score_total_current || 0 }}</div>
                </div>
                <v-divider vertical class="mx-2"></v-divider>
                <div class="text-center summary-stat">
                  <div class="subtitle-2 font-weight-bold">Score Total YTD</div>
                  <div class="summary-stat-value blue--text text--darken-2">{{ kpiScore.score_total_ytd || 0 }}</div>
                </div>
				<v-divider vertical class="mx-2"></v-divider>
                <div class="text-center summary-stat">
                  <div class="subtitle-2 font-weight-bold">Filled Percentage</div>
                  <div class="summary-stat-value blue--text text--darken-2">{{ kpiScore && kpiScore.input_status && kpiScore.input_status.fill_percentage ? kpiScore.input_status.fill_percentage : 0 }}%</div>
                </div>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="d-flex align-center justify-center flex-wrap semester-row">
                <span class="semester-item">
                  <span class="semester-dot semester-dot--s1"></span>
                  Semester 1 YTD
                  <strong class="semester-item__value semester-item__value--s1">{{ kpiScore.score_total_ytd_s1 || 0 }}</strong>
                </span>
                <span class="semester-sep"></span>
                <span class="semester-item">
                  <span class="semester-dot semester-dot--s2"></span>
                  Semester 2 YTD
                  <strong class="semester-item__value semester-item__value--s2">{{ kpiScore.score_total_ytd_s2 || 0 }}</strong>
                </span>
              </div>
            </v-card-text>
          </v-card>
        
       <v-card class="ma-2">
            <div class="monthly-table-scroll">
            <v-data-table
              :headers="monthlyHeaders"
              :items="kpiItems"
              class="elevation-0 py-3"
              dense
              :search="search"
              :height="monthlyTableHeight"
              disable-sort
			  disable-pagination
			  hide-default-footer
			  fixed-header
              :footer-props="{
                        'items-per-page-options': [-1],
                        }"
              >
              <template v-slot:[`item.kpi_name`]="{ item }">
                <div class="d-flex align-center" style="gap:6px;">
                  <span>{{ item.kpi_name }}</span>
                  <v-tooltip bottom v-if="item.is_accounting">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" x-small color="orange darken-3">mdi-calculator-variant</v-icon>
                    </template>
                    <span>KPI Accounting — target Juli-Desember bisa disesuaikan lewat Adjust Accounting</span>
                  </v-tooltip>
                </div>
              </template>

              <template v-slot:[`item.activeInput`]="{ item }">
                <v-card class="pa-2 month-card" outlined>
                  <div class="text-center caption font-weight-bold mb-1"> {{ (item && item.activeInput && item.activeInput.label) ? item.activeInput.label : '-' }}</div>
                  <div class="d-flex align-center justify-center">
                    <div class="text-center flex-grow-1" style="flex: 1 1 50%;">
                      <div class="caption grey--text">Target</div>
                      <div class="month-value mt-2">{{ formatThousandId((item && item.activeInput && item.activeInput.target) ? item.activeInput.target : 0) }}</div>
                    </div>
                    <v-divider vertical class="kanan mx-2 flex-shrink-0"></v-divider>
                    <div class="text-center flex-grow-1" style="flex: 1 1 50%; min-width: 50px;">
                      <div class="caption grey--text">Actual</div>
                      <v-text-field
                        :value="(item && item.activeInput ? (item.activeInput.actual ? formatThousandId(item.activeInput.actual) : '') : '')"
                        @input="val => { if (item && item.activeInput) item.activeInput.actual = formatThousandId(val) }"
                        dense
                        hide-details
                        single-line
                        type="text"
                        class="month-input text-center"
                        style="min-width: 50px; width: 100%;"
                        :disabled="!(item && item.activeInput && item.activeInput.is_fillable)"
                        :class="{ 'grey lighten-3': !(item && item.activeInput && item.activeInput.is_fillable) }"
                      />
                    </div>
                  </div>
                </v-card>
              </template>

			  <!-- template input for target ytd and actual ytd if manual adjustment is true -->
			  <template v-slot:[`item.target_ytd`]="{ item }">
				<v-text-field
					:value="formatThousandId(item ? item.target_ytd : 0)"
					@input="val => { if (item) item.target_ytd = formatThousandId(val) }"
					dense
					hide-details
					single-line
					type="text"
					class="month-input"
					style="width: 96px;"
					:disabled="!(item && item.activeInput && item.activeInput.is_fillable && item.manual_adjustment == 1)"
					:class="{ 'grey lighten-3': !(item && item.activeInput && item.activeInput.is_fillable && item.manual_adjustment == 1) }"
				/>
			  </template>
			  
			  <template v-slot:[`item.actual_ytd`]="{ item }">
				<v-text-field
					:value="formatThousandId(item ? item.actual_ytd : 0)"
					@input="val => { if (item) item.actual_ytd = formatThousandId(val) }"
					dense
					hide-details
					single-line
					type="text"
					class="month-input"
					style="width: 96px;"
					:disabled="!(item && item.activeInput && item.activeInput.is_fillable && item.manual_adjustment == 1)"
					:class="{ 'grey lighten-3': !(item && item.activeInput && item.activeInput.is_fillable && item.manual_adjustment == 1) }"
				/>
			  </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon small color="primary" @click="IsiDetail(item)">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            </div>
        </v-card>
            <v-card-actions class="justify-end pa-3 save-kpi-actions">
              <v-btn 
                color="primary" 
                elevation="2"
                height="40"
                @click="SaveFinalKpi()"
                :disabled="IsUpdateTrue()"
                class="text-white"
              >
                <v-icon left>mdi-file-account</v-icon>
                Save Kpi
              </v-btn>
            </v-card-actions>
          <v-dialog v-model="dialogYear" max-width="620px">
            <v-card v-if="localItem">
              <v-card-title class="white--text year-dialog-header" style="background:#003871;">
                <span class="text-uppercase year-dialog-header__eyebrow">Detail Data Tahunan</span>
                <v-spacer/>
                <v-btn icon dark @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <div class="year-dialog-subtitle">{{ localItem.title }}</div>

              <v-card-text class="pa-0">
                <div class="year-list-wrapper">
                  <div
                    v-for="month in monthsList"
                    :key="month.key"
                    class="year-list-row"
                    :class="{ 'year-list-row--current': isCurrentMonth(month.key) }"
                  >
                    <div class="year-list-month">
                      {{ month.label }}
                      <v-chip v-if="isCurrentMonth(month.key)" x-small color="primary" text-color="white" class="ml-2">Bulan Ini</v-chip>
                    </div>
                    <div class="year-list-fields">
                      <div class="year-list-field year-list-field--target" :class="{ 'year-list-field--highlight': localItem.isAccounting && isSemester1(month.key) }">
                        <span class="year-list-field__label">Target</span>
                        <input type="text" :value="formatThousandId(localItem[month.key].target)" class="data-input" disabled>
                      </div>
                      <div
                        v-if="localItem.isAccounting"
                        class="year-list-field year-list-field--adjustment"
                        :class="{ 'year-list-field--highlight': !isSemester1(month.key) }"
                      >
                        <span class="year-list-field__label">Adjust</span>
                        <input type="text" :value="localItem[month.key].adjustment !== null ? formatThousandId(localItem[month.key].adjustment) : '-'" class="data-input" disabled>
                      </div>
                      <div class="year-list-field year-list-field--actual">
                        <span class="year-list-field__label">Actual</span>
                        <input type="text" :value="formatThousandId(localItem[month.key].actual)" class="data-input" :disabled="shouldDisableActual(month.key)">
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="proses" max-width="420">
            <v-card class="rounded-lg download-modal" style="overflow:hidden;">
              <!-- Header ringkas -->
              <div class="d-flex align-center px-5 py-3 download-modal__header">
                <v-icon dark size="22" class="mr-2">mdi-cloud-download-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold white--text">Download KPI</span>
                <v-spacer></v-spacer>
                <v-btn icon dark small @click="proses = false">
                  <v-icon size="20">mdi-close</v-icon>
                </v-btn>
              </div>

              <v-card-text class="pa-5">
                <!-- User terpilih -->
                <div class="download-modal__label">User Terpilih</div>
                <div
                  class="d-flex align-center download-modal__user"
                  :class="{ 'download-modal__user--empty': !(selectedKpiText && selectedKpiText.trim()) }"
                >
                  <v-icon size="18" class="mr-2" :color="(selectedKpiText && selectedKpiText.trim()) ? 'primary' : 'red'">
                    {{ (selectedKpiText && selectedKpiText.trim()) ? 'mdi-account-check' : 'mdi-account-off' }}
                  </v-icon>
                  <span class="text-truncate">
                    {{ (selectedKpiText && selectedKpiText.trim()) ? selectedKpiText : 'User belum dipilih' }}
                  </span>
                </div>

                <!-- Pilih format -->
                <div class="download-modal__label mt-4">Pilih Format</div>
                <div class="d-flex" style="gap:12px;">
                  <v-btn
                    class="flex-grow-1 download-modal__fmt"
                    color="error"
                    outlined
                    height="46"
                    :disabled="isDisabled()"
                    @click="downloadKpiTemplatePdf(selectedKpi)"
                  >
                    <v-icon left>mdi-file-pdf-box</v-icon>
                    PDF
                  </v-btn>
                  <v-btn
                    class="flex-grow-1 download-modal__fmt"
                    color="success"
                    outlined
                    height="46"
                    :disabled="isDisabled()"
                    @click="downloadKpiTemplateExcel(selectedKpi)"
                  >
                    <v-icon left>mdi-file-excel-box</v-icon>
                    Excel
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </v-card-text>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
	data() {
		return {
			selectedKpi: null,
			selectedHistoryId: null,
			kpiHeaders: [
				{ text: "KPI Name", value: "kpi_name", sortable: false },
				{ text: "Owner", value: "owner_name", sortable: false },

				{ text: "Sharing", value: "user_name", sortable: false },
				{ text: "Annual Target", value: "annual_target", sortable: false },
				{ text: "Bobot", value: "bobot", sortable: false },
				{ text: "Pengukuran", value: "pengukuran", sortable: false },
				{ text: "Sumber", value: "sumber_data", sortable: false },
				{ text: "Unit", value: "unit_name", sortable: false },
				{ text: "Kalkulasi", value: "kalkulasi_name", sortable: false },
				{ text: "Accounting", value: "is_accounting", sortable: false, align: "center" },
			],
			monthlyHeaders: [
				{ text: "KPI Name", value: "kpi_name", align: "start" },
				{ text: "Owner", value: "owner_name", align: "center" },
				{ text: "Unit", value: "unit_name", align: "center" },
				{ text: "Bulan Berjalan", value: "activeInput", align: "center" },
				{ text: "Target YTD", value: "target_ytd", align: "center" },
				{ text: "Actual YTD", value: "actual_ytd", align: "center" },
				{ text: "Bobot", value: "bobot", align: "center" },
				{ text: "Score Current", value: "kpi_score_current", align: "center" },
				{ text: "Score YTD", value: "kpi_score_ytd", align: "center" },
				{ text: "Direction", value: "direction", align: "center" },
				{ text: "Detail", value: "actions", align: "center", sortable: false },
			],
			kpiScore: {},
			snackbar: {
				color: null,
				icon: null,
				mode: null,
				position: "top",
				text: null,
				timeout: 7500,
				title: null,
				visible: false,
			},
			search: "",
			// KPI Target accordion: desktop (>=960px) terbuka, mobile tertutup
			kpiTargetPanel: (typeof window !== 'undefined' && window.innerWidth >= 960) ? 0 : undefined,
			proses: false,
			datas: [],
			kpiItems: [],
			yearHeaders: [],
			allowUpdate: false,
			localItem: null,
			dialogYear: false,
			monthlyTableItems: [],
			selectedItem: null,
			yearlyDetailsDialog: false,
			monthlyItems: [],
			showDropdown: false,
			selectedKpiText: "",
			searchQuery: "",
			currentYear: new Date().getFullYear(),
			totalKpiYtd: 0,
			totalKpiFinal: 0,
		};
	},
	computed: {
		// Daftar bulan untuk list vertikal modal "Detail Data Tahunan"
		// (v-for) — supaya tidak perlu 12 blok markup yang diulang manual.
		monthsList() {
			return [
				{ key: "january", label: "January" },
				{ key: "february", label: "February" },
				{ key: "march", label: "March" },
				{ key: "april", label: "April" },
				{ key: "may", label: "May" },
				{ key: "june", label: "June" },
				{ key: "july", label: "July" },
				{ key: "august", label: "August" },
				{ key: "september", label: "September" },
				{ key: "october", label: "October" },
				{ key: "november", label: "November" },
				{ key: "december", label: "December" },
			];
		},
		// Tinggi tabel "Data Bulanan" menyesuaikan jumlah baris (supaya tidak
		// ada ruang kosong kalau item sedikit), dibatasi maksimum 500px lalu
		// scroll dengan fixed-header kalau item banyak.
		monthlyTableHeight() {
			const rowHeight = 95;
			const headerHeight = 60;
			const count = (this.kpiItems || []).length;
			return Math.min(count * rowHeight + headerHeight, 500);
		},
		user() {
			return this.$store.state.user;
		},
		entity() {
			return this.$store.state.entity;
		},
		isUser() {
			return this.user?.role === "user";
		},
		isAdmin() {
			return this.user?.role === "admin";
		},
		isSuperAdmin() {
			return this.user?.role === "super_admin";
		},
		availableRoles() {
			return this.isSuperAdmin
				? ["user", "admin", "super_admin"]
				: ["user", "admin"];
		},
		entityOptions() {
			return this.entity?.id
				? [{ text: this.entity.name, value: this.entity.id }]
				: [];
		},
		flatHeaders() {
			if (!this.localItem || !this.localItem.headers) return [];

			const headers = [];
			this.localItem.headers.forEach(() => {
				headers.push("Target", "Actual");
			});
			return headers;
		},
		flatInputs() {
			if (!this.localItem || !this.localItem.headers) return [];

			const inputs = [];
			this.localItem.headers.forEach((h) => {
				inputs.push({
					value: this.localItem.valuesMap[h.key]?.target,
					disabled: true,
				});
				inputs.push({
					value: this.localItem.valuesMap[h.key]?.actual,
					disabled: this.shouldDisableActual
						? this.shouldDisableActual(h.key)
						: false,
				});
			});
			return inputs;
		},
		displayYear() {
			if (this.localItem && this.localItem.year) {
				return this.localItem.year;
			}
			return new Date().getFullYear().toString();
		},
		filteredDatas() {
			if (!this.searchQuery || this.searchQuery.trim() === "") {
				return this.datas;
			}
			const query = this.searchQuery.toLowerCase().trim();
			return this.datas.filter((item) => {
				const positionName = (item.position_name || "").toLowerCase();
				const name = (item.name || "").toLowerCase();
				return positionName.includes(query) || name.includes(query);
			});
		},
	},
	mounted() {
		this.waitForTokenAndLoad();
	},
	methods: {
		normalizeNumberInput(value) {
			// null / undefined
			if (value === null || value === undefined) return null;

			// already number
			if (typeof value === "number") return value;

			// handle string type
			if (typeof value === "string") {
				let s = String(value).trim();

				// empty string
				if (s === "") return null;

				// allow single "-" as in-progress negative input
				if (s === "-") return null;

				// remove thousand separators "," before parsing
				s = s.replace(/,/g, "");

				// only allow: optional "-", digits, optional single decimal "."
				if (!/^-?\d*\.?\d*$/.test(s)) return null;

				const num = parseFloat(s);
				return Number.isNaN(num) ? null : num;
			}

			return null;
		},

		formatThousandId(value) {
			const num =
				typeof value === "number" ? value : this.normalizeNumberInput(value);

			if (num === null || Number.isNaN(num)) return "";

			// format with comma as thousand separator
			return new Intl.NumberFormat("en-US", {
				maximumFractionDigits: 2,
			}).format(num);
		},
		async waitForTokenAndLoad() {
			let retries = 5;
			while (!this.$store.getters.isTokenUser && retries-- > 0) {
				await new Promise((resolve) => setTimeout(resolve, 300));
			}
			if (!this.$store.getters.isTokenUser) return;
			if (this.isSuperAdmin) {
				this.getUserlistForSuperAdmin();
				this.$root.$off("entity-updated");
				this.$root.$on("entity-updated", this.getUserlistForSuperAdmin);
			} else if (this.isAdmin) {
				this.getUserlistForAdmin();
			} else if (this.isUser) {
				this.getUserlistForUser();
			}
		},
		async getUserlistForUser() {
			if (!this.$store.getters.isTokenUser) return;

			try {
				const res = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-input/user/list`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				this.datas = res.data.map((item) => ({
					id: item.id,
					user_id: item.user_id,
					name: item.name,
					position_name: item.position_name,
					history_id: item.history_id,
				}));
				console.log("✅ User - KPI input list loaded:", this.datas);

				// Auto: user biasa dengan tepat 1 posisi milik dirinya sendiri
				// → langsung pilih & tampilkan KPI tanpa perlu klik manual.
				if (
					this.datas.length === 1 &&
					Number(this.datas[0].user_id) === Number(this.user?.id)
				) {
					this.selectItem(this.datas[0]);
					this.getInputKpi();
				}
			} catch (err) {
				console.error(
					"❌ User gagal ambil KPI input list:",
					err?.response?.data?.message || err?.message || err
				);
			}
		},
		async getUserlistForAdmin() {
			if (!this.$store.getters.isTokenUser) return;

			try {
				const res = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-input/user/list`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
						params: {
							entity_id: this.entity.id,
						},
					}
				);

				this.datas = res.data.users || res.data;
				console.log("✅ admin:", this.entity.name);
			} catch (err) {
				console.error(
					"❌ Admin gagal ambil userlist:",
					err?.response?.data?.message || err?.message || err
				);
			}
		},
		async getUserlistForSuperAdmin() {
			if (!this.$store.getters.isTokenUser) return;

			try {
				const params = {};
				if (this.entity?.id) {
					params.entity_id = this.entity.id;
				}

				const res = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-input/user/list`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
						params: params,
					}
				);

				this.datas = res.data.users || res.data;
			} catch (err) {
				console.error(
					"❌ Super Admin gagal ambil userlist:",
					err?.response?.data?.message || err?.message || err
				);
			}
		},

		async getInputKpi() {
			if (!this.selectedKpi) {
				this.snackbar = {
					color: "error",
					mode: "snackbar",
					icon: "mdi-alert-circle-outline",
					position: "top",
					text: "Tidak Ada Posisi Yang Di Pilih !",
					timeout: 1500,
					title: null,
					visible: true,
				};
				return;
			}
			this.$store.dispatch("setOverlay", true);
			try {
				await new Promise((resolve) => setTimeout(resolve, 1000));
				const res = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-input/${this.selectedKpi}/${this.selectedHistoryId}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);

				this.kpiItems = res.data.kpi_item || [];
				this.kpiScore = res.data;
				this.snackbar = {
					color: "success",
					icon: "mdi-check-circle",
					mode: "snackbar",
					position: "top",
					text: "Data KPI berhasil dimuat !",
					timeout: 2000,
					title: null,
					visible: true,
				};
			} catch (err) {
				this.snackbar = {
					color: "error",
					mode: "snackbar",
					icon: "mdi-close",
					position: "top",
					text: "Kpi di Setting Tidak Sesuai Degan Periode dan Kpi Detail Belum Di Input Hubungi Admin !",
					timeout: 7500,
					title: null,
					visible: true,
				};
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},

		IsUpdateTrue() {
			return this.kpiScore?.allowUpdate !== true;
		},

		async SaveFinalKpi() {
			if (!this.selectedKpi) {
				this.snackbar = {
					color: "error",
					icon: "mdi-close-circle",
					mode: "snackbar",
					position: "top",
					text: "Tidak Ada Posisi Yang Di Pilih !",
					timeout: 7500,
					title: null,
					visible: true,
				};
				return;
			}

			const errors = [];
			for (const row of this.kpiItems || []) {
				if (row?.activeInput?.is_fillable) {
					const v = row.activeInput.actual;
					if (v === "" || v === null || v === undefined) {
						errors.push(row.kpi_name);
					}
				}
			}
			// if (errors.length > 0) {
			// 	this.snackbar = {
			// 		color: "error",
			// 		mode: "snackbar",
			// 		position: "top",
			// 		text: `Wajib isi Actual KPI : ${errors.join(", ")} !`,
			// 		timeout: 7500,
			// 		title: null,
			// 		visible: true,
			// 		icon: "mdi-alert-circle-outline",
			// 	};
			// 	return;
			// }

			// removing this checker. since user can input any numbers!
			// for (const oke of this.kpiItems || []) {
			// 	const direction = String(oke?.direction || "")
			// 		.toLowerCase()
			// 		.trim();
			// 	const target = Number(oke?.activeInput?.target || 0);
			// 	const actual = Number(oke?.activeInput?.actual || 0);
			// 	if (direction === "lower" && target < actual) {
			// 		this.snackbar = {
			// 			color: "error",
			// 			icon: "mdi-close-circle",
			// 			mode: "snackbar",
			// 			position: "top",
			// 			text: ` KPI ${oke.kpi_name}, Actual tidak boleh lebih besar dari Target !`,
			// 			timeout: 7500,
			// 			title: null,
			// 			visible: true,
			// 		};
			// 		return;
			// 	}
			// }
			const activeInput = [];
			for (const row of this.kpiItems || []) {
				if (row?.activeInput?.is_fillable) {
					activeInput.push({
						id_value: row.activeInput.id_value,
						actual:
							row.activeInput.actual == null || row.activeInput.actual == ""
								? null
								: this.normalizeNumberInput(row.activeInput.actual),
						actual_ytd: this.normalizeNumberInput(row.actual_ytd) || 0,
						target_ytd: this.normalizeNumberInput(row.target_ytd) || 0,
					});
				}
			}
			console.log();
			const payload = { activeInput };
			console.log(payload);
			this.$store.dispatch("setOverlay", true);
			try {
				await new Promise((resolve) => setTimeout(resolve, 1000));
				await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/kpi-input`,
					payload,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				this.snackbar = {
					color: "success",
					mode: "snackbar",
					position: "top",
					text: "✅ Data KPI berhasil disimpan",
					timeout: 1500,
					title: null,
					visible: true,
				};
				await this.getInputKpi();
			} catch (err) {
				this.snackbar = {
					color: "error",
					icon: "error",
					mode: "snackbar",
					position: "top",
					text: err?.response?.data?.message || "❌ Gagal input final KPI",
					timeout: 7500,
					title: null,
					visible: true,
				};
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},

		IsiDetail(item) {
			try {
				if (!item || !Array.isArray(item.values)) {
					console.warn(
						"IsiDetail: item.values tidak tersedia atau bukan array",
						item
					);
					this.localItem = null;
					return;
				}

				const monthNames = [
					"january",
					"february",
					"march",
					"april",
					"may",
					"june",
					"july",
					"august",
					"september",
					"october",
					"november",
					"december",
				];

				const monthlyData = {};
				monthNames.forEach((name) => {
					monthlyData[name] = { target: "", actual: "", adjustment: null };
				});
				const yearFromHeaders =
					Array.isArray(item.headers) && item.headers.length > 0
						? String(item.headers[0].key).split(/[-/]/)[0]
						: null;

				const yearFromValues =
					Array.isArray(item.values) && item.values.length > 0
						? String(item.values[0].periode).split(/[-/]/)[0]
						: null;

				let derivedYear =
					yearFromHeaders ||
					yearFromValues ||
					new Date().getFullYear().toString();

				const parseMonthIndex = (periode) => {
					if (periode == null) return null;
					const str = String(periode).trim();

					const mYMD = str.match(/^\s*(\d{4})[-/](\d{1,2})\s*$/);
					if (mYMD) {
						const mo = mYMD[2].padStart(2, "0");
						const idx = parseInt(mo, 10) - 1;
						return idx >= 0 && idx <= 11 ? idx : null;
					}

					const mM = str.match(/^\s*(\d{1,2})\s*$/);
					if (mM) {
						const idx = parseInt(mM[1], 10) - 1;
						return idx >= 0 && idx <= 11 ? idx : null;
					}

					const lower = str.toLowerCase();
					const idxByName = monthNames.findIndex((n) => lower.includes(n));
					if (idxByName >= 0) return idxByName;

					return null;
				};

				item.values.forEach((v) => {
					const idx = parseMonthIndex(v.periode);
					if (idx == null) {
						console.warn(
							"IsiDetail: periode tidak dapat dipetakan →",
							v.periode,
							v
						);
						return;
					}
					const name = monthNames[idx];

					const targetVal = v.Target ?? v.target ?? v.TARGET ?? "";
					const actualVal = v.Actual ?? v.actual ?? v.ACTUAL ?? "";

					// "Target" baris atas = target LAMA/asli selalu (backend sudah ganti nilai
					// `target` dengan adjustment utk Jul-Des — target_original simpan yg asli).
					// "Adjustment" baris bawah = nilai target_adjustment mentah, kalau ada.
					monthlyData[name].target = v.target_original ?? targetVal;
					monthlyData[name].actual = actualVal;
					monthlyData[name].adjustment = v.target_adjustment ?? null;
				});

				this.localItem = {
					...(this.localItem || {}),
					title: item.kpi_name || "-",
					year: derivedYear,
					allowUpdate:
						item?.allowUpdate ?? this.localItem?.allowUpdate ?? false,
					is_fillable:
						item?.is_fillable ?? this.localItem?.is_fillable ?? false,
					isAccounting: !!item.is_accounting,
					...monthlyData,
				};
				this.dialogYear = true;
			} catch (err) {
				// console.error("IsiDetail: terjadi error", err);
			}
		},

		isCurrentMonth(monthName) {
			const currentMonth = new Date().getMonth();
			const months = [
				"january",
				"february",
				"march",
				"april",
				"may",
				"june",
				"july",
				"august",
				"september",
				"october",
				"november",
				"december",
			];
			const monthIndex = months.findIndex((m) => m === monthName);
			return monthIndex === currentMonth;
		},

		// Semester 1 (Jan-Jun): skor YTD pakai target lama. Semester 2 (Jul-Des): pakai adjustment.
		isSemester1(monthName) {
			const months = [
				"january", "february", "march", "april", "may", "june",
				"july", "august", "september", "october", "november", "december",
			];
			return months.indexOf(monthName) < 6;
		},

		shouldDisableActual() {
			return true;
		},

		closeDialog() {
			this.dialogYear = false;
			this.selectedItem = null;
		},

		toggleDropdown() {
			this.showDropdown = !this.showDropdown;
			if (this.showDropdown) {
				this.$nextTick(() => {
					document.addEventListener("scroll", this.handlePageScroll, true);
					window.addEventListener("scroll", this.handlePageScroll, true);
					document.addEventListener("click", this.handleClickOutside);
				});
			} else {
				this.removeScrollListeners();
			}
		},
		openDropdown() {
			if (!this.showDropdown) {
				this.showDropdown = true;
				this.$nextTick(() => {
					document.addEventListener("scroll", this.handlePageScroll, true);
					window.addEventListener("scroll", this.handlePageScroll, true);
					document.addEventListener("click", this.handleClickOutside);
				});
			}
		},
		handleSearchInput() {
			if (!this.showDropdown) {
				this.openDropdown();
			}
			// If user starts typing after selection, clear the selection
			if (this.selectedKpi && this.searchQuery !== this.selectedKpiText) {
				this.selectedKpi = null;
				this.selectedKpiText = "";
			}
		},

		handlePageScroll(event) {
			const dropdownElement = event.target.closest(".custom-dropdown");
			if (!dropdownElement) {
				this.closeDropdown();
			}
		},

		handleClickOutside(event) {
			const dropdownContainer = event.target.closest(".dropdown-container");
			if (!dropdownContainer) {
				this.closeDropdown();
			}
		},

		closeDropdown() {
			this.showDropdown = false;
			this.removeScrollListeners();
		},

		removeScrollListeners() {
			document.removeEventListener("scroll", this.handlePageScroll, true);
			window.removeEventListener("scroll", this.handlePageScroll, true);
			document.removeEventListener("click", this.handleClickOutside);
		},

		selectItem(item) {
			this.selectedKpi = item.id;
			this.selectedHistoryId = item.history_id || null;
			this.selectedKpiText = `${item.position_name} - ${item.name}`;
			this.searchQuery = this.selectedKpiText;
			this.closeDropdown();
		},

		clearSelection() {
			this.selectedKpi = null;
			this.selectedHistoryId = null;
			this.selectedKpiText = "";
			this.searchQuery = "";
			this.closeDropdown();
		},
		async downloadKpiTemplatePdf(selectedKpi) {
			this.$store.dispatch("setOverlay", true);
			const chartId = selectedKpi.id || selectedKpi.chart_id || selectedKpi;
			const displayName = this.selectedKpiText;
			try {
				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/export/kpi/${chartId}/${this.selectedHistoryId}/pdf`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
						responseType: "blob",
					}
				);

				const blob = new Blob([response.data], { type: "application/pdf" });
				const url = URL.createObjectURL(blob);

				const link = document.createElement("a");
				link.href = url;
				link.download = `${displayName}.pdf`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);

				this.snackbar = {
					color: "success",
					icon: "mdi-check-circle",
					position: "top",
					timeout: 4000,
					title: "Success",
					text: "PDF berhasil diunduh.",
					visible: true,
				};
				this.proses = false;
			} catch (error) {
				console.error("Gagal download PDF:", error);
				this.snackbar = {
					color: "error",
					icon: "mdi-alert-circle",
					position: "top",
					timeout: 6000,
					title: "Error",
					text: "Gagal mengunduh file KPI.",
					visible: true,
				};
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		async downloadKpiTemplateExcel(selectedKpi) {
			this.$store.dispatch("setOverlay", true);
			const chartId = selectedKpi.id || selectedKpi.chart_id || selectedKpi;
			const displayName = this.selectedKpiText;
			try {
				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/export/kpi/${chartId}/${this.selectedHistoryId}/excel`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
						responseType: "blob",
					}
				);

				const blob = new Blob([response.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				const url = URL.createObjectURL(blob);

				const link = document.createElement("a");
				link.href = url;
				link.download = `${displayName}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);

				this.snackbar = {
					color: "success",
					icon: "mdi-check-circle",
					position: "top",
					timeout: 4000,
					title: "Success",
					text: "Excel berhasil diunduh.",
					visible: true,
				};
				this.proses = false;
			} catch (error) {
				console.error("Gagal download Excel:", error);
				this.snackbar = {
					color: "error",
					icon: "mdi-alert-circle",
					position: "top",
					timeout: 6000,
					title: "Error",
					text: "Gagal mengunduh file KPI Excel.",
					visible: true,
				};
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		modale(selectedKpiText) {
			this.proses = true;
			console.log("tes ", selectedKpiText);
		},

		isDisabled() {
			return !this.selectedKpiText || this.selectedKpiText.trim() === "";
		},
	},
	watch: {
		"entity.id": {
			async handler(newVal, oldVal) {
				if (newVal && newVal !== oldVal) {
					await this.$nextTick();
					this.getUserlistForSuperAdmin();
				}
			},
			immediate: false,
		},
	},
};
</script>

<style scoped>
.summary-stat {
	flex: 1 1 0;
	min-width: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0 4px;
}
.summary-stat-value {
	font-size: 2rem;
	font-weight: 400;
	line-height: 1.2;
	margin-top: 4px;
}
@media (max-width: 600px) {
	.summary-stat .subtitle-2 {
		font-size: 0.72rem !important;
		line-height: 1.15;
	}
	.summary-stat-value {
		font-size: 1.4rem;
	}
}
.semester-row {
	font-size: 0.78rem;
	color: rgba(0, 0, 0, 0.6);
}
.semester-item {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	white-space: nowrap;
}
.semester-dot {
	width: 7px;
	height: 7px;
	border-radius: 50%;
	flex-shrink: 0;
}
.semester-dot--s1 {
	background: #43A047;
}
.semester-dot--s2 {
	background: #FB8C00;
}
.semester-item__value {
	font-size: 0.85rem;
	font-weight: 700;
}
.semester-item__value--s1 {
	color: #2E7D32;
}
.semester-item__value--s2 {
	color: #E65100;
}
.semester-sep {
	width: 1px;
	height: 12px;
	background: rgba(0, 0, 0, 0.12);
	margin: 0 14px;
}
@media (max-width: 600px) {
	.semester-row {
		font-size: 0.7rem;
	}
	.semester-item__value {
		font-size: 0.78rem;
	}
	.semester-sep {
		margin: 0 8px;
	}
}
.v-data-footer .v-data-footer__select {
	display: none !important;
}

.v-data-footer .v-data-footer__icons-before,
.v-data-footer .v-data-footer__icons-after,
.v-data-footer .v-data-footer__pagination {
	display: none !important;
}

.v-data-footer {
	border-top: 1px solid rgba(0, 0, 0, 0.12);
	padding: 0;
	min-height: 8px;
}
.kpi-target-table .v-data-table__empty-wrapper td {
	padding: 0 !important;
}
.kpi-target-table .no-data-slot {
	width: 100%;
	margin-left: 20px;
	min-height: 160px;
}

.custom-dropdown {
	position: absolute !important;
	top: 100% !important;
	left: 0 !important;
	right: 0 !important;
	width: 100% !important;
	max-height: 300px !important;
	overflow-y: auto !important;
	background: white !important;
	border: 1px solid #ccc !important;
	border-radius: 4px !important;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
	z-index: 99999 !important;
	margin-top: 2px !important;
}

.dropdown-item {
	padding: 12px 16px !important;
	cursor: pointer !important;
	border-bottom: 1px solid #f0f0f0 !important;
}

.dropdown-item:hover {
	background-color: #f5f5f5 !important;
}

.dropdown-item:last-child {
	border-bottom: none !important;
}

.year-list-wrapper {
	width: 100%;
	max-height: 60vh;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}

.year-list-row {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px 10px;
	padding: 8px 16px;
	border-bottom: 1px solid #eee;
}

.year-list-row:nth-child(even) {
	background-color: #fafafa;
}

.year-list-row--current {
	background-color: #f1f8ff;
}

.year-list-month {
	flex: 0 0 150px;
	font-weight: 600;
	font-size: 0.78rem;
	color: #333;
	display: flex;
	align-items: center;
	white-space: nowrap;
}

.year-list-fields {
	display: flex;
	flex: 1 1 auto;
	gap: 8px;
	justify-content: flex-end;
}

.year-list-field {
	flex: 0 0 92px;
	min-width: 0;
}

.year-list-field__label {
	display: block;
	font-size: 0.65rem;
	font-weight: 600;
	color: #888;
	text-transform: uppercase;
	letter-spacing: 0.4px;
	margin-bottom: 2px;
}

/* Semester 1: highlight Target — biru, ini yang dipakai utk skor. */
.year-list-field--target.year-list-field--highlight .data-input[disabled] {
	background-color: #e3f2fd;
	color: #1565c0;
	font-weight: 700;
}

/* Adjustment redup by default, kecuali di-highlight (Semester 2) — oranye, dipakai utk skor. */
.year-list-field--adjustment .data-input[disabled] {
	color: #bdbdbd;
	font-style: italic;
}

.year-list-field--adjustment.year-list-field--highlight .data-input[disabled] {
	background-color: #fff3e0;
	color: #e65100;
	font-style: normal;
	font-weight: 700;
}

.action-buttons .v-btn .v-btn__content {
	white-space: normal;
	text-align: center;
	line-height: 1.2;
}
.action-buttons .v-btn {
	width: 100%;
	min-height: 40px;
	padding: 0 12px;
}
.action-buttons .v-col {
	display: flex;
	align-items: stretch;
}
@media (max-width: 960px) {
	.action-buttons .v-col + .v-col {
		margin-top: 8px;
	}
	.action-buttons .v-btn {
		font-size: 0.9rem;
	}
	.month-input {
		margin-left: 10px;
		text-align: center;
	}
	.month-input input {
		text-align: center !important;
		font-size: 0.875rem !important;
		font-weight: 500 !important;
	}
	.month-input .v-input__slot input {
		text-align: center !important;
	}
	.month-value {
		font-size: 0.875rem;
		font-weight: 500;
		text-align: center;
	}
	.kanan {
		margin-left: 10px;
	}
}
.data-input {
	width: 100%;
	border: none;
	background: transparent;
	text-align: center;
	padding: 2px;
	font-size: 0.8rem;
	outline: none;
}

.data-input:focus {
	background-color: #e3f2fd;
}

.data-input[disabled] {
	background-color: #f5f5f5;
	color: #666;
	cursor: not-allowed;
}
.year-dialog-header {
	align-items: center;
	min-height: auto !important;
	padding: 10px 20px !important;
}
.year-dialog-header__eyebrow {
	font-size: 0.7rem;
	font-weight: 600;
	opacity: 0.8;
	letter-spacing: 0.6px;
}
.year-dialog-header .v-btn.v-btn--icon {
	width: 32px;
	height: 32px;
}
.year-dialog-subtitle {
	padding: 10px 20px;
	background-color: #fafbfc;
	box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
	font-size: 0.85rem;
	font-weight: 400;
	color: #555;
	line-height: 1.45;
	word-break: break-word;
}
.monthly-table-scroll {
	max-height: 60vh;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
.action-buttons .v-btn {
	width: 100%;
	height: 1px;
}
.keep-disabled-bg.v-btn.v-btn--disabled {
	background-color: var(--v-primary-base) !important;
	color: #000000 !important;
	opacity: 0.6 !important;
	border: 2px solid #030303 !important;
	border-radius: 28px !important;
}

@media (max-width: 600px) {
	.kpi-target-table .no-data-slot {
		min-height: 200px;
	}
}

/* ===== Tabel Data Bulanan — tampilan mobile ===== */
@media (max-width: 600px) {
	/* Full width: buang margin/padding yang menyempitkan area tabel */
	.monthly-data-container {
		padding: 0 !important;
	}
	.monthly-data-container > .v-card {
		margin-left: 0 !important;
		margin-right: 0 !important;
	}
	.monthly-table-scroll {
		max-height: none;
	}

	/* Rapatkan spacing baris stacked (sebelumnya terlalu renggang) */
	.monthly-table-scroll ::v-deep .v-data-table__mobile-row {
		min-height: 30px !important;
		padding: 2px 10px !important;
	}
	.monthly-table-scroll ::v-deep .v-data-table__mobile-row__header {
		font-size: 0.72rem;
		font-weight: 600;
	}
	.monthly-table-scroll ::v-deep .v-data-table__mobile-row__cell {
		font-size: 0.8rem;
	}

	/* Batas antar item jelas: tiap item jadi kartu penuh dengan garis pemisah */
	.monthly-table-scroll ::v-deep .v-data-table__mobile-table-row {
		display: block;
		border: 1px solid #cfe8d0;
		border-left: 4px solid #4CAF50;
		border-radius: 8px;
		margin: 12px 8px;
		padding: 4px 0;
		background: #fff;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
	}
	.monthly-table-scroll ::v-deep .v-data-table__mobile-table-row:nth-child(even) {
		background: #f7faf7;
	}
	/* Nama KPI menonjol sebagai judul item */
	.monthly-table-scroll ::v-deep .v-data-table__mobile-table-row .v-data-table__mobile-row:first-child {
		border-bottom: 1px dashed #e0e0e0;
		margin-bottom: 2px;
	}

	/* Input actual full width biar mudah diisi */
	.monthly-table-scroll ::v-deep .month-input,
	.monthly-table-scroll ::v-deep .month-card {
		width: 100% !important;
	}
}

.download-modal__header {
	background: linear-gradient(to right, #003871, #1976d2);
}
.download-modal__label {
	font-size: 0.7rem;
	font-weight: 600;
	letter-spacing: 0.6px;
	text-transform: uppercase;
	color: #90a4ae;
	margin-bottom: 6px;
}
.download-modal__user {
	padding: 10px 12px;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	background: #f7f9fb;
	font-weight: 500;
	color: #37474f;
}
.download-modal__user--empty {
	border-color: #ffcdd2;
	background: #fff5f5;
	color: #e53935;
}
.download-modal__fmt {
	letter-spacing: 0.3px;
	font-weight: 600;
}

/* ===== Section jadi card terpisah (KPI Target & Data Bulanan) ===== */
.section-card {
	margin: 16px 8px 0;
	border-radius: 10px;
	overflow: hidden;
	background: #fff;
	box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);
}

/* ===== Accordion KPI Target ===== */
/* v-expansion-panels punya width:100% bawaan; dengan margin horizontal .section-card
   jadi 100%+16px dan melewati card utama. Pakai auto biar menyusut sesuai margin. */
.kpi-target-panels.section-card {
	width: auto;
}
.kpi-target-panels ::v-deep .v-expansion-panel-header,
.kpi-target-panels ::v-deep .v-expansion-panel--active > .v-expansion-panel-header {
	min-height: 40px;
	padding-top: 4px;
	padding-bottom: 4px;
}
.kpi-target-panels ::v-deep .v-expansion-panel-content__wrap {
	padding: 0 8px 8px;
}
/* Hilangkan garis/shadow bawaan panel — header berwarna jadi satu-satunya pembatas */
.kpi-target-panels ::v-deep .v-expansion-panel::before {
	box-shadow: none !important;
}
.kpi-target-panels ::v-deep .v-expansion-panel:not(:first-child)::after {
	border-top: none !important;
}

/* Hilangkan padding atas kolom tombol Search/Download supaya sejajar dengan select */
.action-buttons ::v-deep .col {
	padding-top: 0 !important;
}

/* ===== Card utama "Input Tabel KPI" — lebar penuh di mobile ===== */
@media (max-width: 600px) {
	/* Pangkas padding container & card-text utama supaya konten selebar mungkin */
	.v-container--fluid {
		padding: 0 !important;
	}
	.mb-5.rounded-lg ::v-deep .head-cardtext {
		padding: 8px !important;
	}
	/* Selaraskan select "Pilih Posisi" & tombol dengan card section:
	   buang gutter negatif v-row + padding kolom supaya rata di inset 8px. */
	.mb-5.rounded-lg ::v-deep .head-row {
		margin-left: 0 !important;
		margin-right: 0 !important;
	}
	.mb-5.rounded-lg ::v-deep .head-row .col,
	.mb-5.rounded-lg ::v-deep .head-row [class*="col-"] {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
	/* Edge-to-edge: buang sudut membulat & rapatkan ke tepi layar */
	.mb-5.rounded-lg {
		border-radius: 0 !important;
		margin-bottom: 12px !important;
	}
	/* Header tetap beri padding nyaman */
	.mb-5.rounded-lg > .v-card__title {
		padding-left: 12px !important;
		padding-right: 12px !important;
	}
}

.mb-5.rounded-lg {
	padding-bottom: 12px;
}
</style>